import { fetchTotalReadyToSend } from '@api';
import { selectReadyToSendAutomaticSending } from '@store/documents/documents.selector';
import { selectDraftCurrentIdentityReference } from '@store/documents/outgoing/draft.selector';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

const READY_TO_SEND_CACHE_TIME = 10 * 60 * 1000;

export const READY_TO_SEND_COUNT_QUERY_KEY = 'readyToSendCount';

export const useReadyToSendCount = (identityOverride?: string) => {
  const hasAutomaticSending = useSelector(selectReadyToSendAutomaticSending);
  const reduxIdentity = useSelector(selectDraftCurrentIdentityReference);
  const currentIdentity = identityOverride ?? reduxIdentity;

  const { data } = useQuery({
    queryKey: [READY_TO_SEND_COUNT_QUERY_KEY],
    queryFn: fetchTotalReadyToSend,
    staleTime: READY_TO_SEND_CACHE_TIME,
    enabled: hasAutomaticSending,
  });

  if (!data) return 0;

  if (currentIdentity) {
    return data.identities[currentIdentity] || 0;
  }

  return data.total || 0;
};
